var SECONDS = 60;
export var IDLE_MINUTES = 80;
export var IDLE_TIMEOUT = 1000 * SECONDS * IDLE_MINUTES; // 80 min
export var PROMPT_MINUTES = 10;
export var PROMPT_SECONDS = 10 * SECONDS;
export var PROMPT_TIMEOUT = 1000 * PROMPT_SECONDS; // 10 min
export var SESSION_DURATION_HOURS = 12;
export var SESSION_CHECK_INTERVAL = 5000; // 5 sec
// Events that restart the timeout
export var ACTIVE_EVENTS = [
    'mousemove',
    'keydown',
    'wheel',
    'DOMMouseScroll',
    'mousewheel',
    'mousedown',
    'touchstart',
    'touchmove',
    'MSPointerDown',
    'MSPointerMove',
    'visibilitychange',
];
export var MODAL_INACTIVE_TITLE = 'Inactivity Sign Out?';
export var MODAL_INACTIVE_MESSAGE_TIME = function (finishTime) {
    return "For security purposes, you\u2019ll be automatically signed out at ".concat(finishTime, " after being inactive for ").concat(IDLE_MINUTES + PROMPT_MINUTES, " minutes.");
};
export var MODAL_SESSION_TITLE = 'Session Duration Sign Out?';
export var MODAL_SESSION_MESSAGE_TIME = function (finishTime) {
    return "For security purposes, you\u2019ll be automatically signed out at ".concat(finishTime, " after being signed in for ").concat(SESSION_DURATION_HOURS, " hours.");
};
export var MODAL_MESSAGE_NOTES = 'Any open notes will be saved as drafts so that you don’t lose your work. However, any pending edits to member demographics and your settings will not be saved.';
export var COUNTDOWN_LABEL = 'Time remaining: ';
